import { Individual } from "@/Common/Api/Individuals/Dto/Individual";
import { Patient as ResponsePatient } from "@/Common/Api/Patient/Dto/Patient";
import { Guid } from "../Guid";
import { ContactFacetType } from "../Individuals/Enums/ContactFacetType";
import { PreferredPronouns } from "../Individuals/Enums/PreferredPronouns";
import { Patient } from "../Patient/Patient";
import { Person } from "../Person/Person";
import { PortalRegistrationState } from "../Portal/Enums/PortalRegistrationState";

class IndividualMatchingPhoneNumber {
    public Contact_id: Guid;
    public FirstName: string;
    public LastName: string;
    public DateOfBirth: Date;
    public MiddleName: string;
    public SecondName: string;
    public NAM: string;
    public PrefixLookupId: Guid;
    public GenderLookupId: Guid;
    public SuffixLookupId: Guid;
    public PortalSyncState: PortalRegistrationState;
    public PortalProfileId: Guid;
    public PreferredName: string;
    public PreferredPronouns: PreferredPronouns;
    public SpecifiedPreferredPronouns: string;
    public HasPhoneNumber: boolean;
    public ContactFacetId: Guid;
    public ContactFacetType: ContactFacetType;

    constructor(init: Partial<IndividualMatchingPhoneNumber>) {
        Object.assign(this, init);
    }

    public ToIndividual(): Individual {
        let individual = new Individual();
        individual.Contact_id = this.Contact_id;
        individual.FirstName = this.FirstName;
        individual.LastName = this.LastName;
        individual.DateOfBirth = this.DateOfBirth;
        individual.MiddleName = this.MiddleName;
        individual.SecondName = this.SecondName;
        individual.NAM = this.NAM;
        individual.PrefixLookupId = this.PrefixLookupId;
        individual.GenderLookupId = this.GenderLookupId;
        individual.SuffixLookupId = this.SuffixLookupId;
        individual.PortalSyncState = this.PortalSyncState;
        individual.PortalProfileId = this.PortalProfileId;
        individual.PreferredName = this.PreferredName;
        individual.PreferredPronouns = this.PreferredPronouns;
        individual.SpecifiedPreferredPronouns = this.SpecifiedPreferredPronouns;
        individual.ContactFacetId = this.ContactFacetId;
        individual.ContactFacetType = this.ContactFacetType;
        return individual;
    }

    public ToPatient(): Patient {
        let patient = new Patient();
        patient.IndividualResponse = this.ToIndividual();
        patient.PatientResponse = new ResponsePatient();
        patient.Phones = [];
        patient.Addresses = [];
        patient.Emails = [];
        patient.Relationships = [];
        return patient;
    }

    public ToPerson(): Person {
        return Person.FromIndividual(this.ToIndividual());
    }
}

export { IndividualMatchingPhoneNumber };
